import { render } from "./index.vue?vue&type=template&id=20255bc6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=20255bc6&scoped=true&lang=scss"

import exportComponent from "/Volumes/wangxiaochuan/personal/2023-work/2-15-多院区信息化& 20230215MultiCapital/20230215MultiCapital/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20255bc6"]])

export default __exports__